import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import CenteredMessage from '../../components/CenteredMessage';

class ShowIfAnswersCount extends Component {
  render() {
    return (
      <div>
        {this.props.answersCount ? (
          <div>
            {this.props.children}
          </div>
        ):(
          <div 
            style={{
              height: this.props.height,
              position: 'relative',
            }}
          >
            <CenteredMessage>
              <FormattedMessage id="noAnswersInDateRange" />
            </CenteredMessage>
          </div>
        )}
      </div>
    );
  }
}

export default ShowIfAnswersCount;



// WEBPACK FOOTER //
// ./src/components/ShowIfAnswersCount/ShowIfAnswersCount.js